module.exports = __webpack_public_path__ + "static/TiemposTextWeb-Regular-e0e052025ad26ad5bfcbc36f35ee4c65.woff2";